import { useState, useEffect, useRef } from 'react'
import { Allergen, AllergenPayload } from '../../types/catalog'
import { FormField, Input } from '../../components/ui/FormField'
import { TranslationFields } from '../../components/ui/TranslationFields'

interface Props {
  initial?: Allergen | null
  onChange: (payload: AllergenPayload) => void
}

export function AllergenForm({ initial, onChange }: Props) {
  const [code, setCode] = useState(initial?.code ?? '')
  const [translations, setTranslations] = useState(
    initial?.translations ?? [
      { locale: 'en', name: '' },
      { locale: 'es', name: '' },
    ]
  )

  const onChangeRef = useRef(onChange)
  onChangeRef.current = onChange

  useEffect(() => {
    onChangeRef.current({ code, translations })
  }, [code, translations])

  return (
    <>
      <FormField label="Code" hint="Short unique identifier e.g. GLUTEN">
        <Input
          placeholder="GLUTEN"
          value={code}
          onChange={e => setCode(e.target.value.toUpperCase())}
        />
      </FormField>
      <TranslationFields translations={translations} onChange={setTranslations} />
    </>
  )
}
